import { useState } from 'react';
import styled from 'styled-components';

const Placeholder = styled.div`
  animation-duration: 1.5s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: placeHolderShimmer;
  background: ${({ firstColor, secondColor }) => `linear-gradient(to right, ${firstColor} 8%, ${secondColor} 18%, ${firstColor} 33%)`};
  background-size: 800px 104px;
  height: 96px;
  position: relative;

  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }
`;

export const ImagePlaceholder = ({ width, height, src, style, firstColor = '#eeeeee', secondColor = '#dddddd' }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div>
      {!loaded && <Placeholder firstColor={firstColor} secondColor={secondColor} style={{ width, height, ...style }} />}
      <img alt="" src={src} style={{ width, height, display: loaded ? 'block' : 'none', ...style }} onLoad={() => setLoaded(true)} />
    </div>
  );
};
